import React from 'react';
import Button from '../../../components/ui/Button';

const FormActions = ({ 
  isEditing, 
  isLoading, 
  onSave, 
  onSaveAndEnroll, 
  onCancel,
  isBlocked
}) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-spiritual-sm p-6">
      <div className="flex flex-col sm:flex-row items-center justify-end space-y-3 sm:space-y-0 sm:space-x-4">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isLoading}
          className="w-full sm:w-auto"
        >
          Cancel
        </Button>

        <Button
          variant="secondary"
          onClick={onSave}
          loading={isLoading}
          iconName="Save"
          iconPosition="left"
          className="w-full sm:w-auto"
        >
          {isEditing ? 'Update Member' : 'Save Member'}
        </Button>
        <div className="flex flex-col items-end">
          <Button
            variant="default"
            onClick={onSaveAndEnroll}
            loading={isLoading}
            disabled={isLoading || isBlocked}
            iconName="UserPlus"
            iconPosition="left"
            className={`w-full sm:w-auto ${isBlocked ? 'opacity-50 cursor-not-allowed' : ''}`}
            title={isBlocked ? "Blocked members cannot be enrolled for service" : ""}
          >
            {isEditing ? 'Update & Enroll' : 'Save & Enroll'} 
          </Button>
          {isBlocked && (
            <span className="text-xs text-destructive mt-1 font-medium">
              Blocked member cannot be enrolled
            </span>
          )}
        </div>
        
      </div>

      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
          <span>•</span>
          <span>All required fields must be completed</span>
          <span>•</span>
          <span>Changes are saved automatically on form submission</span>
          <span>•</span>
        </div>
      </div>
    </div>
  );
};

export default FormActions;